export default function Hero() {
  return (
    <section className="relative bg-gradient-to-br from-teal-600 via-teal-700 to-teal-900 text-white py-32">
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage:
            'radial-gradient(circle at 20% 50%, rgba(255,255,255,0.3) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(255,255,255,0.2) 0%, transparent 40%)',
        }}
      ></div>
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/20 rounded-full px-4 py-1.5 mb-6">
            <i className="ri-briefcase-4-line text-teal-200 text-sm"></i>
            <span className="text-teal-100 text-sm font-medium">Expert Advisory</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
            Strategic Business Advisory
          </h1>
          <p className="text-lg md:text-xl leading-relaxed text-teal-50 max-w-3xl mx-auto">
            Empowering organizations with expert strategic guidance, operational excellence, and risk-informed decision-making to achieve sustainable competitive advantage and long-term growth.
          </p>
          <div className="mt-10 flex flex-wrap justify-center gap-6 text-sm text-teal-100">
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-line text-teal-300"></i>
              <span>Strategic Planning</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-line text-teal-300"></i>
              <span>Business Advisory</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-line text-teal-300"></i>
              <span>Operations Management</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-line text-teal-300"></i>
              <span>Risk Assessment</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-line text-teal-300"></i>
              <span>Compliance Support</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
